import { MessageCircle } from "lucide-react";

const RAW_NUMBER = (process.env.REACT_APP_WHATSAPP_NUMBER || "27721960889").replace(/[^0-9]/g, "");
const DEFAULT_MESSAGE = "Hi Untamed Gear! I'd like to ask about your rugby shorts and shirts.";

export default function WhatsAppButton({ prefilled }) {
  const text = encodeURIComponent(prefilled || DEFAULT_MESSAGE);
  const href = `https://wa.me/${RAW_NUMBER}?text=${text}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab"
      aria-label="Chat with Untamed Gear on WhatsApp"
      className="fixed bottom-5 right-5 z-[60] flex items-center gap-2 bg-[#25D366] hover:bg-[#1FAD52] text-white shadow-lg shadow-black/40 transition-all rounded-full pl-3 pr-4 py-3 group"
      style={{ boxShadow: "0 6px 24px rgba(37,211,102,0.35)" }}
    >
      <MessageCircle size={22} className="drop-shadow" />
      <span className="hidden sm:inline text-sm font-bold uppercase tracking-wide">Chat</span>
    </a>
  );
}
